import { render, staticRenderFns } from "./BeVenueSlots.vue?vue&type=template&id=25b232d5&scoped=true"
import script from "./BeVenueSlots.vue?vue&type=script&lang=js"
export * from "./BeVenueSlots.vue?vue&type=script&lang=js"
import style0 from "./BeVenueSlots.vue?vue&type=style&index=0&id=25b232d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b232d5",
  null
  
)

export default component.exports